<template>
    <el-dialog visible width="55%"  @close="onCancel">
      <div slot="title" class="authorise-dlg-title flex item-center">
        <img src="@/assets/img/icon-info.png"> 
        <div class="title">{{ $t("authorise.p1") }}</div>
      </div>
      <div class="flex border-normal p-15">
        <img src="@/assets/img/icon-authorise.png" class="authorise-icon">
        <div class="flex-1">
          <p class="authorise-title">{{ $t("authorise.title") }}</p>
          <el-steps direction="vertical" :active="activeStep" class="my-20 authorise-steps" finish-status="success">
            <el-step title="" :description="$t('authorise.step1')"></el-step>
            <el-step title="" :description="$t('authorise.step2')"></el-step>
          </el-steps>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <div type="primary" class="btn-ok" @click="onConfirm">
          <p>{{ $t("authorise.ok") }}</p>
          <p class="mt-10 tips">{{ $t("authorise.okTips") }}</p>
        </div>
        <div class="btn-no" @click="onNoConfirm">
          <p>{{ $t("authorise.no") }}</p>
          <p class="mt-10 tips">{{ $t("authorise.noTips") }}</p>
        </div>
      </span>
    </el-dialog>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import SvgIcon from "@/components/svgIcon/index";
  
  export default {
    name: "AdminAuthorise",
    components: {
      SvgIcon,
    },
    props: {
      onCancel: {
        type: Function,
        default: () => {},
      },
      onConfirm: {
        type: Function,
        default: () => {},
      },
      onNoConfirm: {
        type: Function,
        default: () => {},
      },
      activeStep: {
        type: Number,
        default:-1
      }
    },
    computed: {
      ...mapGetters("common", {
        getUser: "getUser",
        getSite: "getSite",
      }),
    },
    watch: {},
    data() {
      return {
      };
    },
  
    mounted() {},
    methods: {
    },
  };
  </script>
  
  <style scoped>
  ::v-deep .el-dialog .el-dialog__header {
    background-color: transparent;
    border-bottom: none;
    position: relative;
    min-height: 30px;
  }
  .authorise-icon{
    width: 60px;
    height: 60px;
    margin-right: 20px;
  }
  .dialog-footer{
    display: flex;
    justify-content: right;
  }
  .authorise-title{
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 20px;
    color: #283c52;
  }
  .p-15{
    padding: 20px;
  }
  .authorise-steps{
    height: 80px;
  }
  ::v-deep .el-step__description.is-success{
    color:rgb(24, 68, 225);
  }
  ::v-deep .el-step__head.is-success .el-step__icon.is-text{
    background: rgb(24, 68, 225);
    border:0;
  }
  ::v-deep .el-icon-check{
    color: white;
  }
  ::v-deep .el-step__description{
    font-size: 16px;
  }
  ::v-deep .el-step__head.is-process{
    color:#C0C4CC;
    border-color: #C0C4CC;
  }
  ::v-deep .el-step__description.is-wait{
    color:#303133;
  }
  .btn-ok{
    padding: 10px 15px;
    border:1px solid rgb(126, 151, 238);
    border-radius: 4px;
    margin-right: 15px;
    cursor: pointer;
    text-align: left;
    color:rgb(24, 68, 225);
    font-weight: bolder;
  }
  .btn-no{
    padding: 10px 15px;
    cursor: pointer;
    border:1px solid #e5e5e5;
    border-radius: 4px;
    text-align: left;
    font-weight: bolder;
  }
  .tips {
    font-size: 12px;
    font-weight: normal;
  }
  .authorise-dlg-title{
    background: url('~@/assets/img/authorise-bg.png');
    background-size: cover;
    color: white;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding-right: 40px;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  ::v-deep .el-dialog__header{
    padding: 0 !important;

  }
  .authorise-dlg-title img{
    width: 30px;
    margin-right: 20px;
    margin-left: 20px;
  }
  ::v-deep .el-dialog__headerbtn .el-dialog__close{
    color: white;
  }
  .title{
    line-height: 32px;
  }
  </style>
  